import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import apiFetchWeeklyThresholdsEdit from '../../api/WeeklyThresholdsEditAPI';
import { THRESHOLDS_EDIT_REQUEST } from '../actions/types/WeeklyThresholdsEditActionTypes';
import { postThresholdsEditSuccessActionCreator, postThresholdsEditFailureActionCreator } from '../actions/WeeklyThresholdsEditActions';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';

function* doThresholdEditWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const res = yield call(apiFetchWeeklyThresholdsEdit, action.payload);
    yield put(postThresholdsEditSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: <FormattedMessage
        id="notification.threshold.modification.transaction.create.success"
        values={{ transactionProcessingFrequency: process.env.transactionProcessingFrequency }}
      />,
    }));
  } catch (error) {
    yield put(postThresholdsEditFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.bohthresholds.edit.failure'),
    }));
  }
}

function* doThresholdEditWatcher() {
  yield takeLatest(THRESHOLDS_EDIT_REQUEST, doThresholdEditWorker);
}

export default doThresholdEditWatcher;
export { doThresholdEditWorker };
